const dateFormat = new Intl.DateTimeFormat("nl-BE", {
  day: "numeric",
  month: "short",
  year: "numeric",
  timeZone: "Europe/Brussels",
});

const dateTimeFormat = new Intl.DateTimeFormat("nl-BE", {
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Brussels",
});

/** `23 okt. 2026` in Brussels time. */
export function formatDate(iso: string): string {
  return dateFormat.format(new Date(iso));
}

/** `24 okt. 17:05` in Brussels time. */
export function formatDateTime(iso: string): string {
  return dateTimeFormat.format(new Date(iso));
}

/** `<input type="date">` value to the end of that day (the browser's time zone). */
export function endOfDay(day: string): string {
  return new Date(`${day}T23:59:59`).toISOString();
}

const relative = new Intl.RelativeTimeFormat("nl-BE", { numeric: "auto" });

/** "vandaag", "gisteren", "3 dagen geleden", "2 weken geleden", ... */
export function formatAgo(iso: string, now: Date = new Date()): string {
  const days = Math.round((now.getTime() - new Date(iso).getTime()) / 86_400_000);
  if (days < 7) return relative.format(-days, "day");
  if (days < 30) return relative.format(-Math.round(days / 7), "week");
  if (days < 365) return relative.format(-Math.round(days / 30), "month");
  return relative.format(-Math.round(days / 365), "year");
}
